import * as React from 'react';
import styled from 'styled-components';

import { ClydeLogoLink, LogoLinkOptions } from 'src/components/Shared/ClydeLogoLink';

interface ILogosProps {
  partnerLogo: string | null;
  shopName: string;
  showXCoverBranding: boolean | null;
  onLoad: () => void;
}

const StyledLogos = styled.div`
  margin: 24px 8px 0 8px;
  max-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  .partner-logo {
    max-width: calc(50% - 25px); // Add 1px to account for separator
    display: flex;
    margin-right: 24px;
    justify-content: right;
    img {
      max-height: 60px;
      max-width: 145px;
      width: auto;
      height: auto;
      --ms-interpolation-mode: bicubic;
    }
  }

  .separator {
    height: 25px;
    width: 1px;
    background-color: var(--light-gray);
    margin-right: 24px;
  }

  @media (max-width: 550px) {
    margin: 32px 0 0 0;
  }
`;

const Logos = (props: ILogosProps) => {
  const { partnerLogo, shopName, onLoad } = props;

  React.useEffect(() => {
    if (!partnerLogo) {
      onLoad();
    }
  }, [partnerLogo, onLoad]);

  const maybeRenderPartnerLogo = React.useCallback(() => {
    if (!partnerLogo) {
      return null;
    }

    return (
      <>
        <div className="partner-logo">
          <img alt={shopName} onLoad={onLoad} src={partnerLogo} />
        </div>

        <div className="separator" />
      </>
    );
  }, [partnerLogo, shopName]);

  return (
    <StyledLogos>
      {maybeRenderPartnerLogo()}

      <div className="clyde-logo">
        <ClydeLogoLink logoType={LogoLinkOptions.WORDMARK} />
      </div>
    </StyledLogos>
  );
};

export default Logos;
